import React from 'react';
import FreePlayFloridaSubmissionForm from '../components/FreePlayFloridaSubmissionForm';

const SubmitGamePage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <FreePlayFloridaSubmissionForm />
    </div>
  );
};

export default SubmitGamePage;